module.exports = __webpack_public_path__ + "img/Villa_Borna_40.a41d60f8.jpg";